// Country-aware Amazon links.
// -----------------------------------------------------------------------------
// The book has different ASINs across regions, so we use Amazon's own smart
// short links (which resolve to the correct storefront + edition per visitor):
//   • amzn.in — Amazon India
//   • amzn.eu — Amazon Europe (auto-routes to co.uk/de/fr/it/es/nl/pl/se)
//   • a.co    — Amazon Americas (defaults to amazon.com)
// -----------------------------------------------------------------------------
const IN_LINK = "https://amzn.in/d/04vnoZQJ";
const EU_LINK = "https://amzn.eu/d/07WmCDRM";
const AM_LINK = "https://a.co/0dQsUom6";

export const AMAZON_LINKS = {
  default: AM_LINK,
  // India + South-Asian neighbours
  IN: IN_LINK,
  BD: IN_LINK, LK: IN_LINK, NP: IN_LINK, BT: IN_LINK, PK: IN_LINK, MV: IN_LINK,
  // European Amazon storefronts (amzn.eu smart-routes)
  GB: EU_LINK, DE: EU_LINK, FR: EU_LINK, IT: EU_LINK, ES: EU_LINK,
  NL: EU_LINK, PL: EU_LINK, SE: EU_LINK, IE: EU_LINK, AT: EU_LINK,
  BE: EU_LINK, CH: EU_LINK, DK: EU_LINK, FI: EU_LINK, NO: EU_LINK,
  PT: EU_LINK, GR: EU_LINK, CZ: EU_LINK, HU: EU_LINK, RO: EU_LINK,
  SK: EU_LINK, SI: EU_LINK, HR: EU_LINK, BG: EU_LINK, LU: EU_LINK,
  EE: EU_LINK, LV: EU_LINK, LT: EU_LINK, CY: EU_LINK, MT: EU_LINK,
  IS: EU_LINK,
  // Americas + APAC (Amazon smart-link resolves to amazon.com)
  US: AM_LINK, CA: AM_LINK, MX: AM_LINK, BR: AM_LINK,
  AU: AM_LINK, NZ: AM_LINK, JP: AM_LINK, SG: AM_LINK,
  // Middle East
  AE: AM_LINK, SA: AM_LINK, EG: AM_LINK, TR: AM_LINK,
};

export function resolveAmazonLink(countryCode) {
  if (!countryCode) return AMAZON_LINKS.default;
  const cc = countryCode.toUpperCase();
  return AMAZON_LINKS[cc] || AMAZON_LINKS.default;
}

// Detect the user's country via a free geo-IP lookup, with fallbacks.
// Result is cached for the session.
export async function detectCountry() {
  if (typeof window === "undefined") return null;
  const cached = window.sessionStorage.getItem("eom_country");
  if (cached) return cached;
  try {
    const res = await fetch("https://ipwho.is/", { cache: "default" });
    if (res.ok) {
      const j = await res.json();
      if (j && j.success && j.country_code) {
        window.sessionStorage.setItem("eom_country", j.country_code);
        return j.country_code;
      }
    }
  } catch {
    /* ignore */
  }
  // Fallback: browser locale (e.g. en-GB → GB)
  const locale = (navigator.language || "en-US").split("-")[1];
  const cc = (locale || "US").toUpperCase();
  window.sessionStorage.setItem("eom_country", cc);
  return cc;
}
